import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

// CSS global do AOS (animações ao rolar)
import "aos/dist/aos.css"

createApp(App).use(router).mount("#app");
